import { serialize } from 'object-to-formdata'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
import {
  RecruitingStatus,
  MpEmploymentJob,
  MpEmploymentJobPayload,
} from 'types/mp_employment_job'

const resource = 'mp_employment_jobs'

export const requests = {
  update: async (params: {
    id: number
    recruiting_status?: RecruitingStatus
  }) => {
    return await axiosForGigbaseBiz.patch<DataResponse<MpEmploymentJob>>(
      mergeURL(resource, params.id.toString()),
      params,
    )
  },
  create: async (params: MpEmploymentJobPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse<MpEmploymentJob>>(
      resource,
      serialize(params),
    )
  },
  updateContent: async (jobId: number, params: MpEmploymentJobPayload) => {
    return await axiosForGigbaseBiz.patch<DataResponse<MpEmploymentJob>>(
      mergeURL(resource, jobId.toString(), 'update_contents'),
      serialize(params),
    )
  },
}
